import clsx from 'clsx';
import React from 'react';
import { CSSTransition } from 'react-transition-group';
import { getComponentClasses } from '../../../../utils/app';
import { FixedViewportElement } from '../../../FixedViewportElement';

interface Props {
    isActive: boolean;
    isScrollableSmallScreens?: boolean;
    hasOpeningAndClosingAnimation?: boolean;
    animationDuration?: number;
    isClosing?: boolean;
    hasAdminBarOffset?: boolean;
    enableScroll?: boolean;
    variations?: string[];
    onClick?: () => void;
    children?: React.ReactNode;
}

export default class FullscreenOverlay extends React.Component<Props> {
    overlayBody() {
        return (
            <div>
                {!this.props.isClosing && (
                    <div
                        role="button"
                        onClick={this.props.onClick}
                        className="fullscreen-overlay__content"
                    >
                        {this.props.children}
                    </div>
                )}
            </div>
        );
    }

    animatedOverlayBody() {
        return (
            <CSSTransition
                in={true}
                classNames="fullscreen-overlay-"
                timeout={this.props.animationDuration || 230}
                appear={true}
                unmountOnExit
            >
                {this.overlayBody()}
            </CSSTransition>
        );
    }

    renderBody() {
        const data: { [key: string]: boolean } = {};
        const classes = clsx(getComponentClasses('fullscreen-overlay', this.props.variations), {
            'fullscreen-overlay--scrollable-small-screen': this.props.isScrollableSmallScreens,
        });

        if (this.props.isActive) {
            data['data-fullscreen-overlay-active'] = true;

            if (this.props.enableScroll) {
                data['data-enable-scroll'] = true;
            }
        }

        if (this.props.hasAdminBarOffset) {
            data['data-offset-admin-bar'] = true;
        }

        return (
            <div className={classes} {...data}>
                {this.props.hasOpeningAndClosingAnimation
                    ? this.animatedOverlayBody()
                    : this.overlayBody()}
            </div>
        );
    }

    render() {
        if (this.props.isActive && !this.props.isClosing) {
            return <FixedViewportElement>{this.renderBody()}</FixedViewportElement>;
        }

        return this.renderBody();
    }
}
